<template>
  <div class="wrapper" ref="milt_select_widget">
    <div class="milt-select-widget" @click="shop_pop_up = !shop_pop_up">
      <label v-if="selected_items.length > 0"
        >{{ selected_items.length | validate }} Selected</label
      >
      <label v-else>Select</label>
      <img src="@/assets/icons/arrow_down_black.svg" />
    </div>
    <div
      class="select-items-widget"
      v-if="shop_pop_up"
      v-closable="{
        exclude: ['milt_select_widget'],
        handler: 'hidePopUp',
      }"
    >
      <div class="select-item">
        <input type="checkbox" @change="selectAll" value="All" id="_all" />
        <label for="_all">{{ all_label }}</label>
      </div>
      <div class="select-item" v-for="(item, index) in input_data" :key="index">
        <input
          type="checkbox"
          @change="onChange($event, item)"
          :value="item.value"
          :id="`id_${item.value}`"
          :checked="selected_items.includes(item.value)"
        />
        <label :for="`id_${item.value}`">{{ item.name | validate }}</label>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "milt-select-widget",
  props: {
    all_label: {
      type: String,
      default: "All",
    },
    content: {
      type: Array,
      default: function () {
        return [];
      },
    },
    value: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      input_data: [],
      selected_items: [],
      shop_pop_up: false,
    };
  },
  computed: {},
  watch: {
    content(val) {
      let vm = this;
      vm.input_data = val;
    },
    value(val) {
      let vm = this;
      vm.selected_items = val;
    },
  },
  mounted() {
    let vm = this;
    vm.input_data = vm.content;
    if (vm.value) {
      vm.selected_items = vm.value;
    }
  },
  methods: {
    hidePopUp() {
      let vm = this;
      vm.shop_pop_up = false;
    },
    onChange({ target }, item) {
      let vm = this;
      if (target.checked) {
        vm.selected_items.push(item.value);
      } else {
        const index = vm.selected_items.indexOf(item.value);
        if (index > -1) {
          vm.selected_items.splice(index, 1);
        }
      }
      vm.$emit("onSubmit", vm.selected_items);
      vm.$emit("input", vm.selected_items);
    },
    selectAll({ target }) {
      let vm = this;
      if (target.checked) {
        vm.selected_items = vm.input_data.map((item) => item.value);
      } else {
        vm.selected_items = [];
      }
      vm.$emit("onSubmit", vm.selected_items);
      vm.$emit("input", vm.selected_items);
    },
  },
};
</script>

<style lang="scss" scoped>
$assets: "~@/assets";
.wrapper {
  position: relative;
  width: 100%;
  border-radius: 5px;
  .milt-select-widget {
    display: flex;
    border: 1px solid #ddd;
    border-radius: 5px;
    width: 100%;
    height: 45px;
    background: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0px 20px;
  }
  .select-items-widget {
    position: absolute;
    top: 50px;
    left: 0px;
    right: 0px;
    background: #ffffff;
    border: 1px solid #f2f4f8;
    box-sizing: border-box;
    border-radius: 5px;
    overflow-y: auto;
    z-index: 99999;
    .select-item {
      border-bottom: 1px solid #f2f4f8;
      padding: 15px 15px;
      display: flex;
      align-items: center;
      label {
        margin-top: 2px;
        margin-left: 7px;
        text-decoration: none;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}
</style>